import { render, staticRenderFns } from "./BillingTransactionHistory.vue?vue&type=template&id=487f9419&scoped=true&"
import script from "./BillingTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./BillingTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f9419",
  null
  
)

export default component.exports